import React from 'react'
import seoAnalysis from '../../assets/images/seo-analysis.png'
import {Link} from "gatsby";

const AnalysisForm = () => {
    return (
        <div className="seo-analysis-section pb-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="analysis-img">
                            <img src={seoAnalysis} alt="analysis" />
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="analysis-form">
                            <span className="sub-title">Je Teste</span>
                            <h2>Compte de test version BETA</h2>
                            <p>Vous souhaitez la création d'un compte PRO associe à votre email d'entreprise? Vous pourrez tester gratuitement la solution avec l'offre d'emploi de votre choix, pour les utilisateurs que vous sélectionnerais.
                            </p>
                            
                            <form>
                                {/*
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" id="your_name" placeholder="Name" />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input type="email" className="form-control" id="your_email" placeholder="Email" />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" id="your_number" placeholder="Phone Number" />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control" id="website" placeholder="Website URL" />
                                        </div>
                                    </div>
                                </div>
                                */}

                                <div className="btn-box">

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnalysisForm;